// =========================================================================================@@
// Last Updated Date: May 18, 2025
// Last Updated By: Steven
// Status Level: 2
// ===========================================================================================

import React from 'react'
import PropTypes from 'prop-types'
import ListMenuButton from 'src/sites/kits/Global/components/ListMenuButton'
import {
   ArrowSquareDown,
   CheckSquare,
   FileArrowUp,
   Paragraph,
   RadioButton,
   Textbox,
   TextT
} from '@phosphor-icons/react'

const actionButtonProps = {
   paddingHorizontal: '8px'
}

const FormBuilderActionsMenu = ({ elementTypes, onButtonClick }) => {
   return (
      <div className="w-[270px] p-2">
         {elementTypes.includes('info') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'info'
               })}
               name="Text Explanation or Information"
               icon={<TextT size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('text') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'text'
               })}
               name="Single-line Text Input"
               icon={<Textbox size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('paragraph') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'text',
                  multiline: true
               })}
               name="Paragraph Text Input"
               icon={<Paragraph size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('radio') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'radio',
                  options: ['']
               })}
               name="Multiple Choice"
               icon={<RadioButton size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('checkbox') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'checkbox',
                  options: ['']
               })}
               name="Checkboxes"
               icon={<CheckSquare size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('dropdown') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'dropdown',
                  options: ['']
               })}
               name="Dropdown"
               icon={<ArrowSquareDown size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
         {elementTypes.includes('file') && (
            <ListMenuButton
               onClick={() => onButtonClick({
                  type: 'file',
                  options: ['']
               })}
               name="File Upload"
               icon={<FileArrowUp size={16} weight="bold" className="opacity-40" />}
               {...actionButtonProps}
            />
         )}
      </div>
   )
}

FormBuilderActionsMenu.propTypes = {
   // eslint-disable-next-line react/forbid-prop-types
   elementTypes: PropTypes.array.isRequired,
   onButtonClick: PropTypes.func.isRequired
}

export default FormBuilderActionsMenu
